import { Platform } from '@angular/cdk/platform';
import { Component, ElementRef, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ProductCategory } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { AuthButton } from '../../auth/auth-button/auth-button';
import { SiteName } from '../../common/site-name/site-name';
import { ShoppingCartButton } from '../../shopping/shopping-cart-button/shopping-cart-button';
import { MainMenuButton } from '../main-menu-button/main-menu-button';
import { SearchButton } from '../search-button/search-button';

@Component({
  selector: 'toolbar[app-main-toolbar]',
  imports: [
    SiteName,
    ShoppingCartButton,
    AuthButton,
    SearchButton,
    RouterModule,
    MainMenuButton,
  ],
  templateUrl: './main-toolbar.html',
  styleUrl: './main-toolbar.scss',
})
export class MainToolbar implements OnInit {
  constructor(
    private productApi: ProductApiService,
    private elRef: ElementRef,
    private platform: Platform,
  ) { }

  ngOnInit(): void {
    this.findProductCategories();

    if (this.platform.isBrowser) {

      const observer = new IntersectionObserver(
        ([e]) => {
          // 当元素不再 100% 可见时，说明它已经开始“挤压”边界，即处于 sticky 状态
          e.target.classList.toggle('is-sticky', e.intersectionRatio < 1);
        },
        {
          // 关键：设置 -1px 的阈值，这样当元素碰到顶部时会触发
          threshold: [1],
          rootMargin: '-1px 0px 0px 0px',
        },
      );
      observer.observe(this.elRef.nativeElement);
    }
  }

  get appname(): string {
    return environment.appname;
  }

  get bestSellersNo(): string {
    return environment.collection.best_sellers;
  }

  get newArrivalsNo(): string {
    return environment.collection.new_arrivals;
  }

  categories: ProductCategory[] = [];
  loading: boolean = false;
  async findProductCategories() {
    try {
      this.loading = true;
      this.categories = await this.productApi.findProductCategories();
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

}
